import type {
  GuesteriaPartnerDestinationType,
  GuesteriaPartnerConnectionStatus,
  GuesteriaPartnerRow,
} from "./guesteriaPartnersModel";

export type GuesteriaPartnersFiltersState = {
  searchQuery: string;
  destinationTypes: GuesteriaPartnerDestinationType[];
  connectionStatuses: GuesteriaPartnerConnectionStatus[];
};

export const DEFAULT_GUESTERIA_PARTNERS_FILTERS: GuesteriaPartnersFiltersState =
  {
    searchQuery: "",
    destinationTypes: [],
    connectionStatuses: [],
  };

export const GUESTERIA_PARTNER_DESTINATION_TYPE_OPTIONS: readonly GuesteriaPartnerDestinationType[] =
  ["COUNTRY", "REGION", "CITY"] as const;

export const GUESTERIA_PARTNER_CONNECTION_OPTIONS: readonly GuesteriaPartnerConnectionStatus[] =
  ["installed", "unavailable"] as const;

export function filterGuesteriaPartnerRows(
  rows: GuesteriaPartnerRow[],
  filters: GuesteriaPartnersFiltersState,
): GuesteriaPartnerRow[] {
  const q = filters.searchQuery.trim().toLowerCase();
  return rows.filter(
    (row) =>
      (!q || row.name.toLowerCase().includes(q)) &&
      (filters.destinationTypes.length === 0 ||
        (row.destinationType !== null &&
          filters.destinationTypes.includes(row.destinationType))) &&
      (filters.connectionStatuses.length === 0 ||
        filters.connectionStatuses.includes(row.connectionStatus)),
  );
}

export function countActiveGuesteriaFilters(
  filters: GuesteriaPartnersFiltersState,
): number {
  return (
    filters.destinationTypes.length +
    filters.connectionStatuses.length +
    (filters.searchQuery.trim() ? 1 : 0)
  );
}
